module.exports = __webpack_public_path__ + "img/22_62.210e2edc.png";